<template>
  <div class="step3">
    <div class="card-list">
      <div class="card flex-60 pay">
        <div class="card-title">{{ $t('cart_page.checkout_type') }}</div>
        <div class="card-body">
          <div class="pay-item" :class="{ active: payType=='delivery'}">
            <div class="label-group">
              <input type="radio" id="delivery_checkbox" name="payType" value="delivery" v-model="payType"><label for="delivery_checkbox">{{ $t('cart_page.checkout_type1') }}</label>
            </div>  
            <div class="desc">
              {{ $t('cart_page.checkout_type1_desc') }}
            </div>
          </div>
          <div class="pay-item" :class="{ active: payType=='credit'}">
            <div class="label-group">
              <input type="radio" id="credit_checkbox" name="payType" value="credit" v-model="payType"><label for="credit_checkbox">{{ $t('cart_page.checkout_type2') }}</label>
            </div>  
            <div class="icons">
              <div class="icon-item" v-for="(item,index) in credit_cards" :key="index">
                <img :src="item">
              </div>
            </div>
            <div class="desc">
              {{ $t('cart_page.checkout_type2_desc') }}
            </div>
          </div>
          <div class="group-info-item mt-10 flex-x">
            <div class="item-title">{{ $t('cart_page.card_num') }}: </div>
            <div class="item-content">
              <input type="text" :placeholder="$t('cart_page.card_num_placeholder')" :disabled="payType=='delivery'" v-model="formdata.cardNmber">
            </div>
          </div>
          <div class="group-info-item mt-10 flex-m">
            <div class="item-title">{{ $t('cart_page.security_code') }}: </div>
            <div class="item-content">
              <input type="text" :placeholder="$t('cart_page.security_code_placeholder')" :disabled="payType=='delivery'" v-model="formdata.securityCode">
            </div>
          </div>
          <div class="group-info-item mt-10 flex-m">
            <div class="item-title">{{ $t('cart_page.card_date') }}: </div>
            <div class="item-content">
              <input type="text" placeholder="MM" :disabled="payType=='delivery'"><span class="slash">/</span><input type="text" placeholder="YYYY" :disabled="payType=='delivery'" v-model="formdata.cardYear">
            </div>
          </div>
        </div>
      </div>
      <div class="card hide-on-pad">
        <div class="card-title">{{ $t('cart_page.price_title' )}}</div>
        <div class="card-body">
          <p class="cart-info">{{ $t('cart_page.count' )}}<span>{{ totalCount | formatPrice }}</span></p>
          <p class="cart-info">{{ $t('cart_page.ship_fee' )}}<span>{{ shipPrice | formatPrice }}</span></p>
          <p class="cart-info coupon">{{ $t('cart_page.coupon' )}}<span>{{ couponPrice }}</span></p>
          <p class="cart-info total">{{ $t('cart_page.total' )}}<span>{{  totalPrice | formatPrice }}</span></p>
        </div>
      </div>
    </div>

    <div class="btns">
      <div class="btn btn-grey" @click="handelBack">{{ $t('cart_page.back' )}}</div>
      <div class="btn btn-orange" @click="handleNext">{{ $t('cart_page.checkout_confirm' )}}</div>
    </div>
  </div>
</template>

<script>
  import AmericanExpress_logo from '../images/AmericanExpress_logo.png'
  import discover_logo from '../images/discover_logo.png'
  import visa_logo from '../images/visa_logo.png'
  import mastercard_logo from '../images/mastercard_logo.png'
  

  export default {
    name: 'cart-step3',
    props: {
      cars: {
        type: Array,
        default: () => []
      },
      totalCount: {
        type: Number,
        default: 0
      },
      shipPrice: {
        type: Number,
        default: 0
      },
      couponPrice: {
        type: String,
        default: 0
      },
      totalPrice: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        credit_cards: [AmericanExpress_logo,discover_logo,mastercard_logo,visa_logo],
        // delivery: true,
        // credit: false,
        payType: 'delivery',
        formdata: {
          cardNmber: '',
          securityCode: '',
          cardDate: '',
          cardMonth: '',
          cardYrar: '',
        },
      }
    },
    filters: {
      formatPrice(value) {
        let priceText = 0;
        if(value && value!='undefined') priceText = value;
        const priceArr = String(priceText).split('');
        let price = '';
        priceArr.forEach((item, index) => {
            if (index >= 3 && index % 3 == 0) {
                price = priceArr[priceArr.length - index - 1] + ',' + price;
            } else {
                price = priceArr[priceArr.length - index - 1] + price;
            }
        })
        return '$'+price;
      },
    },
    methods: {
      handelBack() {
        this.$emit('next','ship');
      },
      handleNext() {
        this.$emit('next','success');
      }
    }
  }
</script>

<style lang="less" scoped>
.step3 {
  .card-list {
    @media (max-width: 992px) {
      padding: 0 20px; 
      margin-top: 20px;
      margin-bottom: 20px !important;
    }
    .card {
      margin-left: 60px;
      position: relative;
      &.flex-60 {
        flex: 0 0 60%;
        @media (max-width: 992px) {
          flex: 0 0 100%;
        }
        .card-body {
          padding-top: 0;
        }
      }
      .card-body {
        .cart-info.total {
          position: absolute;
          width: calc(100% - 30px);
          bottom: 15px;
          padding-top: 40px;
        }
      }
    }
    .pay-item {
      margin-left: -15px;
      margin-right: -15px;
      padding: 50px;
      width: calc(100% + 30px);
      @media (max-width: 992px) {
        margin-left: 0;
        margin-right: 0;
        width: 100%;
        padding: 15px;
        border-bottom: 1px solid #E6E6E6;
        &:nth-last-child(1) {
          border-bottom: unset;
        }
      }
      position: relative;
      &.active {
        background: #F7F8FA;
        @media (min-width: 992px) {
          background: #E2E2E2;
          border-bottom: 2px solid #D0D0D0;
        }
      }
      .label-group {

      }
      .icons {
        display: flex;
        position: absolute;
        top: 55px;
        right: 40px;
        @media (max-width: 992px) {
          right: 0;
          top: 10px;
        }
        .icon-item {
          height: 30px;
          margin-right: 14px;
          position: relative;
          &:nth-last-child(1) {
            margin-right: 0;
          }
          &:nth-child(3)::before {
            content: '';
            background: #1B1E72;
            width: 120%;
            height: 80%;
            top: 10%;
            left: -10%;
            position: absolute;
            z-index: -1;
          }
          img {
            height: 100%;
            display: block;
          }
        }
      }
      .desc {
        margin-top: 20px;
        font-size: 0.8rem;
      }
    }
    .slash {
      font-size: 28px;
      padding: 0 10px;
    }
  }
}
</style>